import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=7e63c36c&scoped=true"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"
import style0 from "./Link.vue?vue&type=style&index=0&id=7e63c36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e63c36c",
  null
  
)

export default component.exports